import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

import Collapse from "@mui/material/Collapse";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";

import HomeIcon from "@mui/icons-material/Home";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import DashboardIcon from "@mui/icons-material/Dashboard";

import SettingsIcon from "@mui/icons-material/Settings";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import AssignmentIcon from "@mui/icons-material/Assignment";
import AssignmentLateIcon from "@mui/icons-material/AssignmentLate";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import GroupIcon from "@mui/icons-material/Group";
import DeveloperModeIcon from "@mui/icons-material/DeveloperMode";

import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import LocalShippingTwoToneIcon from "@mui/icons-material/LocalShippingTwoTone";
import makeStyles from "@mui/styles/makeStyles";
import { ListItemButton } from "@mui/material";

export default function PageMenu(props) {
  const classes = usePageMenuStyles();

  const webUserSelector = useSelector((state) => state.authentication.webUser);
  const userSelector = useSelector((state) => state.authentication.user);
  const roles = userSelector?.roles;

  const notesOpenSelector = useSelector(
    (state) => state.utility.vehicle_notes_open
  );

  const hasAdminRole = !!roles?.admin;
  const hasGstManageRole = !!roles?.gst_manage;
  const hasSvetnaRole = !!roles?.svetna;
  const hasSvetnaBuyerRole = !!roles?.svetna_buyer;
  const hasSvetnaAdminRole = !!roles?.svetna_admin;

  const isAdmin = webUserSelector
    ? Number(webUserSelector.roleid) === 2
      ? true
      : false
    : false;

  let isHudson = false;
  let isHoland = false;
  const clientName =
    webUserSelector && webUserSelector.client
      ? webUserSelector.client.clientname
      : null;
  if (
    clientName !== null &&
    clientName.toLowerCase().includes("larry hudson")
  ) {
    isHudson = true;
  }
  if (
    clientName !== null &&
    clientName.toLowerCase().includes("holand leasing")
  ) {
    isHoland = true;
  }

  const [adminExpand, setAdminExpand] = useState(false);
  const [titlesExpand, setTitlesExpand] = useState(false);
  const [riReportsExpand, setRiReportsExpand] = useState(false);
  const [reportsExpand, setReportsExpand] = useState(false);
  const [accountingExpand, setAccountingExpand] = useState(false);
  const [transportExpand, setTransportExpand] = useState(false);
  const [svetnaExpand, setSvetnaExpand] = useState(true);

  let hasDvsMenu = true;
  if (hasSvetnaBuyerRole) {
    hasDvsMenu = false;
  }

  return (
    <div>
      {hasSvetnaRole && (
        <>
          <ListItemButton onClick={() => setSvetnaExpand(!svetnaExpand)}>
            <ListItemIcon>
              <DashboardIcon />
            </ListItemIcon>
            <ListItemText primary="Svetna Menu" />
            {svetnaExpand ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
          <Collapse in={svetnaExpand} timeout="auto" unmountOnExit>
            <ListItemButton
              component={Link}
              to="/svetna/vehicledashboard"
              className={classes.nested}
            >
              <ListItemIcon>
                <DirectionsCarIcon />
              </ListItemIcon>
              <ListItemText primary="Vehicle Dashboard" />
            </ListItemButton>
            <ListItemButton
              component={Link}
              to="/svetna/scan"
              className={classes.nested}
            >
              <ListItemIcon>
                <DeveloperModeIcon />
              </ListItemIcon>
              <ListItemText primary="Svetna Scan" />
            </ListItemButton>
            <ListItemButton
              component={Link}
              to="/svetna/dealers"
              className={classes.nested}
            >
              <ListItemIcon>
                <GroupIcon />
              </ListItemIcon>
              <ListItemText primary="Svetna Dealers" />
            </ListItemButton>
            <ListItemButton
              component={Link}
              to="/svetna/reports"
              className={classes.nested}
            >
              <ListItemIcon>
                <GroupIcon />
              </ListItemIcon>
              <ListItemText primary="Reports" />
            </ListItemButton>
            <ListItemButton
              component={Link}
              to="/svetna/upload_sold"
              className={classes.nested}
            >
              <ListItemIcon>
                <GroupIcon />
              </ListItemIcon>
              <ListItemText primary="Upload Sold" />
            </ListItemButton>
            {hasSvetnaAdminRole && (
              <>
                <ListItemButton
                  component={Link}
                  to="/svetna/users"
                  className={classes.nested}
                >
                  <ListItemIcon>
                    <GroupIcon />
                  </ListItemIcon>
                  <ListItemText primary="Svetna Users" />
                </ListItemButton>
              </>
            )}
          </Collapse>
        </>
      )}
      {hasDvsMenu && (
        <>
          <ListItemButton component={Link} to="/">
            <ListItemIcon>
              <HomeIcon />
            </ListItemIcon>
            <ListItemText primary="Home" />
          </ListItemButton>
          <ListItemButton component={Link} to="/dashboard">
            <ListItemIcon>
              <DashboardIcon />
            </ListItemIcon>
            <ListItemText primary="Dashboard" />
          </ListItemButton>
          {isAdmin && (
            <>
              <ListItemButton component={Link} to="/vehicles">
                <ListItemIcon>
                  <AssignmentIcon />
                </ListItemIcon>
                <ListItemText primary="Assignments Rec'd" />
              </ListItemButton>
              {notesOpenSelector.total > 0 && (
                <ListItemButton component={Link} to="/vehicle_notes/incomplete">
                  <ListItemIcon>
                    <AssignmentLateIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary={`Notes Queue (${notesOpenSelector.total})`}
                    primaryTypographyProps={{ color: "secondary" }}
                  />
                </ListItemButton>
              )}
              <ListItemButton component={Link} to="/clientLoads">
                <ListItemIcon>
                  <AssignmentIcon />
                </ListItemIcon>
                <ListItemText primary="Client Loads" />
              </ListItemButton>
              <ListItemButton component={Link} to="/clientLocations">
                <ListItemIcon>
                  <AssignmentIcon />
                </ListItemIcon>
                <ListItemText primary="Client Locations" />
              </ListItemButton>
              <ListItemButton component={Link} to="/clientTransporters">
                <ListItemIcon>
                  <AssignmentIcon />
                </ListItemIcon>
                <ListItemText primary="Client Transporters" />
              </ListItemButton>
              <ListItemButton component={Link} to="/clientDrivers">
                <ListItemIcon>
                  <AssignmentIcon />
                </ListItemIcon>
                <ListItemText primary="Client Drivers" />
              </ListItemButton>
              <ListItemButton component={Link} to="/invoicebatches">
                <ListItemIcon>
                  <MonetizationOnIcon />
                </ListItemIcon>
                <ListItemText primary="Invoice Batches" />
              </ListItemButton>
              <ListItemButton component={Link} to="/paperworkbatches">
                <ListItemIcon>
                  <AssignmentTurnedInIcon />
                </ListItemIcon>
                <ListItemText primary="Paperwork Batches" />
              </ListItemButton>

              {/* RI REPORTS */}
              <ListItemButton
                onClick={() => setRiReportsExpand(!riReportsExpand)}
              >
                <ListItemIcon>
                  <DirectionsCarIcon />
                </ListItemIcon>
                <ListItemText primary="RI Reports" />
                {riReportsExpand ? <ExpandLess /> : <ExpandMore />}
              </ListItemButton>
              <Collapse in={riReportsExpand} timeout="auto" unmountOnExit>
                <ListItemButton
                  component={Link}
                  to="/management/ri-dot-outstanding"
                  style={{ paddingLeft: "50px" }}
                >
                  <ListItemText primary="DOT Outstanding" />
                </ListItemButton>
                <ListItemButton
                  component={Link}
                  to="/management/ri-dot-status"
                  style={{ paddingLeft: "50px" }}
                >
                  <ListItemText primary="DOT Status" />
                </ListItemButton>
                <ListItemButton
                  component={Link}
                  to="/management/ri-needs-applied"
                  style={{ paddingLeft: "50px" }}
                >
                  <ListItemText primary="RI Needs Applied" />
                </ListItemButton>
                <ListItemButton
                  component={Link}
                  to="/management/riUserTraining"
                  style={{ paddingLeft: "50px" }}
                >
                  <ListItemText primary="NHTSA User Training" />
                </ListItemButton>
                <ListItemButton
                  component={Link}
                  to="/management/nhtsaConformityEdit"
                  style={{ paddingLeft: "50px" }}
                >
                  <ListItemText primary="NHTSA Conformity Editor" />
                </ListItemButton>
                <ListItemButton
                  component={Link}
                  to="/management/nhtsaConformityGenerate"
                  style={{ paddingLeft: "50px" }}
                >
                  <ListItemText primary="NHTSA Conformity Generate" />
                </ListItemButton>
                <ListItemButton
                  component={Link}
                  to="/management/ri-customs-submitted-report"
                  style={{ paddingLeft: "50px" }}
                >
                  <ListItemText primary="Customs Submitted Report" />
                </ListItemButton>
                <ListItemButton
                  component={Link}
                  to="/management/ri-nhtsa-audit-report"
                  style={{ paddingLeft: "50px" }}
                >
                  <ListItemText primary="NHTSA Audit Report" />
                </ListItemButton>
                <ListItemButton
                  component={Link}
                  to="/management/ri-nhtsa-ivr"
                  style={{ paddingLeft: "50px" }}
                >
                  <ListItemText primary="NHTSA IVR Report" />
                </ListItemButton>
              </Collapse>

              {/* MANAGER REPORTS */}
              <ListItemButton onClick={() => setReportsExpand(!reportsExpand)}>
                <ListItemIcon>
                  <DirectionsCarIcon />
                </ListItemIcon>
                <ListItemText primary="Reports" />
                {reportsExpand ? <ExpandLess /> : <ExpandMore />}
              </ListItemButton>
              <Collapse in={reportsExpand} timeout="auto" unmountOnExit>
                <ListItemButton
                  component={Link}
                  to="/clientOpenContracts"
                  style={{ paddingLeft: "50px" }}
                >
                  <ListItemText primary="RI Open Contracts" />
                </ListItemButton>
                <ListItemButton
                  component={Link}
                  to="/clientHudsonPaperwork"
                  style={{ paddingLeft: "50px" }}
                >
                  <ListItemText primary="CS Paperwork" />
                </ListItemButton>
                <ListItemButton
                  component={Link}
                  to="/management/ri-problems"
                  style={{ paddingLeft: "50px" }}
                >
                  <ListItemText primary="RI Problem Report" />
                </ListItemButton>
                <ListItemButton
                  component={Link}
                  to="/management/ri-status"
                  style={{ paddingLeft: "50px" }}
                >
                  <ListItemText primary="RI Status Report" />
                </ListItemButton>
                <ListItemButton
                  component={Link}
                  to="/management/activity"
                  style={{ paddingLeft: "50px" }}
                >
                  <ListItemText primary="Staff Volume Report" />
                </ListItemButton>
                <ListItemButton
                  component={Link}
                  to="/management/autoims"
                  style={{ paddingLeft: "50px" }}
                >
                  <ListItemText primary="AutoIMS Reconcile" />
                </ListItemButton>
                <ListItemButton
                  component={Link}
                  to="/management/report-charges"
                  style={{ paddingLeft: "50px" }}
                >
                  <ListItemText primary="Charge Breakdown Report" />
                </ListItemButton>
                {hasGstManageRole && (
                  <ListItemButton
                    component={Link}
                    to="/management/gst-report"
                    style={{ paddingLeft: "50px" }}
                  >
                    <ListItemText primary="GST Report (Daily)" />
                  </ListItemButton>
                )}

                {hasGstManageRole && (
                  <ListItemButton
                    component={Link}
                    to="/management/gst-submissions"
                    style={{ paddingLeft: "50px" }}
                  >
                    <ListItemText primary="GST Submissions" />
                  </ListItemButton>
                )}

                <ListItemButton
                  component={Link}
                  to="/management/customer-volumes"
                  style={{ paddingLeft: "50px" }}
                >
                  <ListItemText primary="Customer Volumes" />
                </ListItemButton>
                <ListItemButton
                  component={Link}
                  to="/management/customer-stats"
                  style={{ paddingLeft: "50px" }}
                >
                  <ListItemText primary="Customer stats" />
                </ListItemButton>
              </Collapse>

              {/* Admin */}
              <ListItemButton onClick={() => setAdminExpand(!adminExpand)}>
                <ListItemIcon>
                  <SettingsIcon />
                </ListItemIcon>
                <ListItemText primary="Admin" />
                {adminExpand ? <ExpandLess /> : <ExpandMore />}
              </ListItemButton>
              <Collapse in={adminExpand} timeout="auto" unmountOnExit>
                <ListItemButton
                  component={Link}
                  to="/vehicle_notes/all"
                  style={{ paddingLeft: "50px" }}
                >
                  <ListItemText primary="Notes Queue" />
                </ListItemButton>
                <ListItemButton
                  component={Link}
                  to="/management/massUpdate"
                  style={{ paddingLeft: "50px" }}
                >
                  <ListItemText primary="Mass Update" />
                </ListItemButton>
                <ListItemButton
                  component={Link}
                  to="/management/massUpdateBondReleases"
                  style={{ paddingLeft: "50px" }}
                >
                  <ListItemText primary="Mass Update Bond Releases" />
                </ListItemButton>
                <ListItemButton
                  component={Link}
                  to="/admin/auctions"
                  style={{ paddingLeft: "50px" }}
                >
                  <ListItemText primary="Auctions" />
                </ListItemButton>
                <ListItemButton
                  component={Link}
                  to="/admin/clients"
                  style={{ paddingLeft: "50px" }}
                >
                  <ListItemText primary="Clients" />
                </ListItemButton>
                <ListItemButton
                  component={Link}
                  to="/admin/users"
                  style={{ paddingLeft: "50px" }}
                >
                  <ListItemText primary="Users" />
                </ListItemButton>
                <ListItemButton
                  component={Link}
                  to="/admin/titleStatusTypes"
                  style={{ paddingLeft: "50px" }}
                >
                  <ListItemText primary="Title Status Types" />
                </ListItemButton>
                <ListItemButton
                  component={Link}
                  to="/admin/titleApplicationTypes"
                  style={{ paddingLeft: "50px" }}
                >
                  <ListItemText primary="Title Application Types" />
                </ListItemButton>
                <ListItemButton
                  component={Link}
                  to="/admin/rackRates"
                  style={{ paddingLeft: "50px" }}
                >
                  <ListItemText primary="Rack Rates (NEW)" />
                </ListItemButton>
                <ListItemButton
                  component={Link}
                  to="/admin/pdfFormFields"
                  style={{ paddingLeft: "50px" }}
                >
                  <ListItemText primary="PDF Form Fields" />
                </ListItemButton>
              </Collapse>
            </>
          )}
          {!isAdmin && (
            <>
              <ListItemButton component={Link} to="/vehicles">
                <ListItemIcon>
                  <AssignmentIcon />
                </ListItemIcon>
                <ListItemText primary="Assignments Rec'd" />
              </ListItemButton>
              <ListItemButton component={Link} to="/clientLoads">
                <ListItemIcon>
                  <AssignmentIcon />
                </ListItemIcon>
                <ListItemText primary="Loads" />
              </ListItemButton>
              <ListItemButton component={Link} to="/clientLocations">
                <ListItemIcon>
                  <AssignmentIcon />
                </ListItemIcon>
                <ListItemText primary="Locations" />
              </ListItemButton>
              <ListItemButton component={Link} to="/clientTransporters">
                <ListItemIcon>
                  <AssignmentIcon />
                </ListItemIcon>
                <ListItemText primary="Transporters" />
              </ListItemButton>
              <ListItemButton component={Link} to="/clientDrivers">
                <ListItemIcon>
                  <AssignmentIcon />
                </ListItemIcon>
                <ListItemText primary="Drivers" />
              </ListItemButton>

              {/* CLIENT REPORTS */}
              <ListItemButton onClick={() => setReportsExpand(!reportsExpand)}>
                <ListItemIcon>
                  <DirectionsCarIcon />
                </ListItemIcon>
                <ListItemText primary="Reports" />
                {reportsExpand ? <ExpandLess /> : <ExpandMore />}
              </ListItemButton>
              <Collapse in={reportsExpand} timeout="auto" unmountOnExit>
                {(isHudson || isHoland) && (
                  <ListItemButton
                    component={Link}
                    to="/clientOpenContracts"
                    style={{ paddingLeft: "50px" }}
                  >
                    <ListItemText primary="RI Open Contracts" />
                  </ListItemButton>
                )}
                {(isHudson || isHoland) && (
                  <ListItemButton
                    component={Link}
                    to="/clientHudsonPaperwork"
                    style={{ paddingLeft: "50px" }}
                  >
                    <ListItemText primary="CS Paperwork" />
                  </ListItemButton>
                )}
                <ListItemButton
                  component={Link}
                  to="/management/ri-problems"
                  style={{ paddingLeft: "50px" }}
                >
                  <ListItemText primary="RI Problem Report" />
                </ListItemButton>
                <ListItemButton
                  component={Link}
                  to="/management/ri-status"
                  style={{ paddingLeft: "50px" }}
                >
                  <ListItemText primary="RI Status Report" />
                </ListItemButton>
                <ListItemButton
                  component={Link}
                  to="/client-reports/pending-titles"
                  style={{ paddingLeft: "50px" }}
                >
                  <ListItemText primary="Pending Titles" />
                </ListItemButton>
                {hasGstManageRole && (
                  <ListItemButton
                    component={Link}
                    to="/management/gst-submissions"
                    style={{ paddingLeft: "50px" }}
                  >
                    <ListItemText primary="GST Submissions" />
                  </ListItemButton>
                )}
              </Collapse>
            </>
          )}
          {/* TITLES */}
          {isAdmin && (
            <>
              <ListItemButton onClick={() => setTitlesExpand(!titlesExpand)}>
                <ListItemIcon>
                  <DirectionsCarIcon />
                </ListItemIcon>
                <ListItemText primary="Titles" />
                {titlesExpand ? <ExpandLess /> : <ExpandMore />}
              </ListItemButton>
              <Collapse in={titlesExpand} timeout="auto" unmountOnExit>
                <ListItemButton
                  component={Link}
                  to="/titles/pending"
                  style={{ paddingLeft: "50px" }}
                >
                  <ListItemText primary="Pending Titles" />
                </ListItemButton>
                <ListItemButton
                  component={Link}
                  to="/titles/pendingBMV"
                  style={{ paddingLeft: "50px" }}
                >
                  <ListItemText primary="Pending BMV" />
                </ListItemButton>
                <ListItemButton
                  component={Link}
                  to="/titles/pendingDOT"
                  style={{ paddingLeft: "50px" }}
                >
                  <ListItemText primary="Pending DOT/BOND Release" />
                </ListItemButton>
                <ListItemButton
                  component={Link}
                  to="/titles/vaultVsBond"
                  style={{ paddingLeft: "50px" }}
                >
                  <ListItemText primary="Vault vs Bond" />
                </ListItemButton>
                <ListItemButton
                  component={Link}
                  to="/admin/titlesSent"
                  style={{ paddingLeft: "50px" }}
                >
                  <ListItemText primary="Titles Sent" />
                </ListItemButton>
              </Collapse>
            </>
          )}
          {/* ACCOUNTING */}
          {isAdmin && (
            <>
              <ListItemButton
                onClick={() => setAccountingExpand(!accountingExpand)}
              >
                <ListItemIcon>
                  <MonetizationOnIcon color="primary" />
                </ListItemIcon>
                <ListItemText primary="Accounting" />
                {accountingExpand ? <ExpandLess /> : <ExpandMore />}
              </ListItemButton>
              <Collapse in={accountingExpand} timeout="auto" unmountOnExit>
                <ListItemButton
                  component={Link}
                  to="/accounting/unbilled-units"
                  style={{ paddingLeft: "50px" }}
                >
                  <ListItemText primary="Unbilled Units" />
                </ListItemButton>
                <ListItemButton
                  component={Link}
                  to="/accounting/invoice-summary"
                  style={{ paddingLeft: "50px" }}
                >
                  <ListItemText primary="Invoice Summary" />
                </ListItemButton>
                <ListItemButton
                  component={Link}
                  to="/accounting/monthly-summary"
                  style={{ paddingLeft: "50px" }}
                >
                  <ListItemText primary="Monthly Summary" />
                </ListItemButton>
                <ListItemButton
                  component={Link}
                  to="/accounting/one-off-invoices"
                  style={{ paddingLeft: "50px" }}
                >
                  <ListItemText primary="One Off Invoice" />
                </ListItemButton>
                <ListItemButton
                  component={Link}
                  to="/accounting/bisbee-reconcile"
                  style={{ paddingLeft: "50px" }}
                >
                  <ListItemText primary="Bisbee Reconcile" />
                </ListItemButton>
                <ListItemButton
                  component={Link}
                  to="/accounting/yearly-tax-report"
                  style={{ paddingLeft: "50px" }}
                >
                  <ListItemText primary="Yearly Tax Report" />
                </ListItemButton>
                <ListItemButton
                  component={Link}
                  to="/accounting/user-time-report"
                  style={{ paddingLeft: "50px" }}
                >
                  <ListItemText primary="User Time Report" />
                </ListItemButton>
              </Collapse>
            </>
          )}
          {/* TRANSPORT */}
          {isAdmin && (
            <>
              <ListItemButton
                onClick={() => setTransportExpand(!transportExpand)}
              >
                <ListItemIcon>
                  <LocalShippingTwoToneIcon color="primary" />
                </ListItemIcon>
                <ListItemText primary="Transport POC" />
                {transportExpand ? <ExpandLess /> : <ExpandMore />}
              </ListItemButton>
              <Collapse in={transportExpand} timeout="auto" unmountOnExit>
                <ListItemButton
                  component={Link}
                  to="/transportation/transport-list"
                  style={{ paddingLeft: "50px" }}
                >
                  <ListItemText primary="Transport List" />
                </ListItemButton>
              </Collapse>
            </>
          )}
          <ListItemButton component={Link} to="/scanner">
            <ListItemIcon>
              <AddAPhotoIcon />
            </ListItemIcon>
            <ListItemText primary="Scanner / Photos" />
          </ListItemButton>
        </>
      )}

      <ListItemButton component={Link} to="/login">
        <ListItemIcon>
          <ExitToAppIcon />
        </ListItemIcon>
        <ListItemText primary="Logout" />
      </ListItemButton>
    </div>
  );
}

const usePageMenuStyles = makeStyles((theme) => ({
  nested: {
    paddingLeft: theme.spacing(4),
  },
}));
